import * as types from '../constantes/linksSystem';

export const CreateLinksSystemReducer = (state = {}, action) => {
  switch (action.type) {
    case types.CREATE_LINKS_SYSTEMS_REQUEST:
      return {
        loading: true,
      };

    case types.CREATE_LINKS_SYSTEMS_SUCESS:
      return {
        loading: false,
        success: true,
      };

    case types.CREATE_LINKS_SYSTEMS_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    case types.LINKS_SYSTEMS_RESET:
      return {};

    default:
      return state;
  }
};

export const SearchLinksSystemReducer = (state = { loading: true, links: [] }, action) => {
  switch (action.type) {
    case types.SEARCH_LINKS_SYSTEMS_REQUEST:
      return {
        loading: true,
      };

    case types.SEARCH_LINKS_SYSTEMS_SUCESS:
      return {
        loading: false,
        linksSystem: action.payload,
      };

    case types.SEARCH_LINKS_SYSTEMS_ERROR:
      return {
        loading: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const SearchSpecifyLinksSystemReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case types.SEARCH_SPECIFY_LINKS_SYSTEMS_REQUEST:
      return {
        loading: true,
      };
    case types.SEARCH_SPECIFY_LINKS_SYSTEMS_SUCESS:
      return {
        loading: false,
        specifyLinksSystem: action.payload,
      };
    case types.SEARCH_SPECIFY_LINKS_SYSTEMS_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const UpdateLinksSystemReducer = (state = {}, action) => {
  switch (action.type) {
    case types.UPDATE_LINKS_SYSTEMS_REQUEST:
      return {
        loading: true,
      };

    case types.UPDATE_LINKS_SYSTEMS_SUCESS:
      return {
        loading: false,
        success: true,
      };

    case types.UPDATE_LINKS_SYSTEMS_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    case types.UPDATE_LINKS_SYSTEMS_RESET:
      return {};

    default:
      return state;
  }
};
